<script lang="ts" setup>
    import BaseButton from '@/components/BaseButton.vue';
    import BaseIcon from '@/components/BaseIcon.vue';
    import IconMinus from '@/components/icons/IconMinus.vue';
    import IconPlus from '@/components/icons/IconPlus.vue';
    import useProductStore from '@/store/product.store';
    import { getEmptyImageField, getEmptyTextField } from '@/utils/emptyProduct';
    import { ref } from 'vue';

    const productStore = useProductStore();

    const isAddFieldVisible = ref(false);

    function addImageField() {
        productStore.addField(getEmptyImageField());
        isAddFieldVisible.value = false;
    }

    function addTextField() {
        productStore.addField(getEmptyTextField());
        isAddFieldVisible.value = false;
    }
</script>
<template>
    <div class="w-full">
        <BaseButton
            class="w-full !border-border-primary"
            variant="outlined"
            :label="$t('add_field_label')"
            :title="$t('addContentTitle')"
            @click="isAddFieldVisible = !isAddFieldVisible"
        >
            <div class="flex w-full flex-row items-center justify-between px-4">
                <span>{{ $t('add_field_label') }}</span>
                <IconMinus v-if="isAddFieldVisible" />
                <IconPlus v-else />
            </div>
        </BaseButton>
        <div
            v-if="isAddFieldVisible"
            class="absolute top-10 z-10 flex h-32 w-full flex-col rounded-2xl border bg-white shadow hover:cursor-pointer"
        >
            <BaseButton
                :default-classes="false"
                :class="[
                    'flex h-1/2 w-full flex-row items-center gap-2 rounded-t-2xl border-none bg-white p-2 text-left text-text',
                    'transition-colors duration-300',
                    'hover:bg-hover-tertiary hover:text-white',
                ]"
                @click="addImageField"
            >
                <BaseIcon
                    type="outlined"
                    name="PhotoIcon"
                    class="h-6 w-6"
                />
                {{ $t('add_image_field_label') }}
            </BaseButton>
            <BaseButton
                :default-classes="false"
                :class="[
                    'flex h-1/2 w-full flex-row items-center gap-2 rounded-b-2xl border-none bg-white p-2 text-left text-text',
                    'transition-colors duration-300',
                    'hover:bg-hover-tertiary hover:text-white',
                ]"
                @click="addTextField"
            >
                <span class="flex h-6 w-6 flex-row items-center justify-center font-serif text-2xl">T</span>
                {{ $t('add_text_field_label') }}
            </BaseButton>
        </div>
    </div>
</template>
